import classNames from "classnames";
import { forwardRef } from "react";
export const Input = forwardRef(function InputFC(props, ref) {
    const { className, ...otherProps } = props;
    return (<input ref={ref} className={classNames("h-[46px] border border-gray-light p-3 outline-none focus:border-gray-shuttle disabled:border-transparent disabled:bg-gray-bg", className)} {...otherProps}/>);
});
